/** Explains an average's denominator, which leaves out posts that don't report the metric. */
export function averageTooltip(metric: string, reportingCount: number): string {
  const noun = metric.toLowerCase();
  if (reportingCount === 0) return `No posts report ${noun} yet`;
  if (reportingCount === 1) return `Average of the 1 post that reports ${noun}`;
  return `Average across the ${reportingCount} posts that report ${noun}`;
}
